export default class Untersuchungsbefundvariante {
    public untersuchungsbefundvariante: number | null = null;
    public bezeichnung: string | null = null;
    public sort: number | null = null;

    constructor(data?: Partial<Untersuchungsbefundvariante>) {
        Object.assign(this, data);
    }
}
